module.exports = __webpack_public_path__ + "static/humainly-small-5b668aa94f81391f1fb6bb408fb9845c.png";